import get from 'lodash/get';

/**
 * @param {Array} values array of string or array of objects
 * @param propertyLabel
 * @param propertyValue
 */
export default function (values, propertyLabel, propertyValue) {
  if (propertyLabel && propertyValue) {
    return values.map((item) => ({
      value: get(item, propertyValue),
      label: get(item, propertyLabel)
    }));
  }
  if (propertyLabel) {
    return values.map((item) => ({
      value: get(item, propertyLabel),
      label: get(item, propertyLabel)
    }));
  }
  return values.map((item) => ({
    value: item,
    label: item
  }));
}
